import axiosInstance from "../../utils/axiosInstance";

// notification
import { notify } from "../../components/alerts";
import { setCompany, setLoading } from "../../store/slices/company";
import { AppDispatch } from "../../store/store";
import {
  ICreateBranch,
  ICreateBranchResponse,
  ICreateCompany,
  IJoinCompanyBranch,
  IRcNumberSearch,
} from "../../store/@types/company";
import { NavigateFunction } from "react-router-dom";
import { getErrorMessage } from "./apiError";

const companiesEndpoint = "/api/v1/client/companies";

type ISearchParams = { rc_number: string };

export const getCompanyRCNumber = async (
  dispatch: AppDispatch,
  formData: ISearchParams,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post<IRcNumberSearch>(
      `${companiesEndpoint}/search-rc-number`,
      formData,
    );

    if (!response.data.success) {
      notify({ message: response.data.message, type: "error" });
    } else {
      dispatch(setCompany(response.data?.data));
    }
  } catch (err) {
    notify({
      message: getErrorMessage(err, "Unable to search this RC number."),
      type: "error",
    });
  } finally {
    dispatch(setLoading());
  }
};

export const create_company = async (
  dispatch: AppDispatch,
  form: ICreateCompany,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(`${companiesEndpoint}`, form);

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Unable to create company."),
      type: "error",
    });
  } finally {
    dispatch(setLoading());
  }
};

export const join_branch = async (
  dispatch: AppDispatch,
  form: IJoinCompanyBranch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      `${companiesEndpoint}/join-branch`,
      form,
    );

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Unable to join company branch."),
      type: "error",
    });
  } finally {
    dispatch(setLoading());
  }
};

export const create_branch = async (
  dispatch: AppDispatch,
  form: ICreateBranch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post<ICreateBranchResponse>(
      `${companiesEndpoint}/branches`,
      form,
    );

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Unable to create company branch.",
      );
    }

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Unable to create company branch."),
      type: "error",
    });
  } finally {
    dispatch(setLoading());
  }
};

export const get_company_details = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get(`${companiesEndpoint}/details`);
    dispatch(setCompany(response.data?.data));
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Unable to load company details."),
      type: "error",
    });
  } finally {
    dispatch(setLoading());
  }
};

// test
